// extracted by mini-css-extract-plugin
export default {"title":"_066b9baf92","inner_title":"_96f382a0d0","charge_btn":"df9841c482"};